import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-2 max-md:hidden',
    drawerContent: 'flex h-full w-full flex-col gap-10',
    titleWrapper: 'flex items-center gap-2 md:justify-between',
    title: 'text-xl font-semibold md:text-3xl',
    list: 'flex flex-wrap gap-2',
    filterButton: 'flex-center h-8 px-0 md:hidden',
    filterButtonChildren: 'flex-center gap-[6px] max-md:normal-case md:gap-2',
    filterIcon: 'h-6 w-6 md:h-8 md:w-8',
    drawer: 'py-[20px] pb-0 sm:py-12 sm:pb-0',
    resetButton:
      'text-secondary-hover h-fit self-end p-0 text-sm font-semibold',
    filters: '-mr-3 flex flex-col overflow-y-auto pr-3',
    footer: 'sticky bottom-0 mt-auto flex bg-white pb-[10px]',
    showProductsButton:
      'bg-primary hover:bg-blue bg-blue-dark w-full rounded py-3 font-medium text-white disabled:cursor-not-allowed disabled:bg-gray-300'
  },
  variants: {
    color: {
      primary: 'text-black'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
